// Organic "roots / rivers" flow — everything begins with Place.
const BRANCHES = [
  { label: "People", x: 120 },
  { label: "Language", x: 240 },
  { label: "Story", x: 385 },
  { label: "Water", x: 500 },
  { label: "Plants", x: 615 },
  { label: "Animals", x: 760 },
  { label: "Fire", x: 852 },
  { label: "Memory", x: 940 },
];

const SPINE = [
  { label: "Knowledge", y: 560 },
  { label: "Reflection", y: 660 },
  { label: "Stewardship", y: 760 },
  { label: "Future Generations", y: 860 },
];

export default function RootsFlow() {
  const placeX = 500;
  const placeY = 70;
  const branchY = 320;

  return (
    <div data-testid="roots-flow" className="w-full">
      <svg viewBox="0 0 1020 920" className="w-full h-auto" preserveAspectRatio="xMidYMid meet">
        <defs>
          <radialGradient id="sf-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#D4A373" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#D4A373" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* PLACE -> branches (roots) */}
        {BRANCHES.map((b, i) => (
          <path
            key={`root-${i}`}
            d={`M ${placeX} ${placeY + 10} C ${placeX} ${branchY - 120}, ${b.x} ${placeY + 120}, ${b.x} ${branchY - 26}`}
            fill="none"
            stroke="#D4A373"
            strokeOpacity="0.32"
            strokeWidth="1"
            strokeDasharray="2 3"
            style={{ animation: `wk-dash ${16 + i * 1.5}s linear infinite` }}
          />
        ))}

        {/* branches -> Knowledge (rivers converge) */}
        {BRANCHES.map((b, i) => (
          <path
            key={`conv-${i}`}
            d={`M ${b.x} ${branchY + 22} C ${b.x} ${branchY + 140}, ${placeX} ${SPINE[0].y - 130}, ${placeX} ${SPINE[0].y - 22}`}
            fill="none"
            stroke="#D4A373"
            strokeOpacity="0.16"
            strokeWidth="1"
            strokeDasharray="2 4"
            style={{ animation: `wk-dash ${20 + i}s linear infinite` }}
          />
        ))}

        {/* spine */}
        {SPINE.slice(0, -1).map((s, i) => (
          <line
            key={`spine-${i}`}
            x1={placeX}
            y1={s.y + 12}
            x2={placeX}
            y2={SPINE[i + 1].y - 12}
            stroke="#D4A373"
            strokeOpacity="0.3"
            strokeWidth="1"
            strokeDasharray="2 3"
            style={{ animation: `wk-dash ${14 + i * 2}s linear infinite` }}
          />
        ))}

        {/* PLACE node */}
        <circle cx={placeX} cy={placeY} r="26" fill="url(#sf-glow)" />
        <circle cx={placeX} cy={placeY} r="4" fill="#E6CCB2" />
        <text x={placeX} y={placeY - 34} textAnchor="middle" className="font-display" fill="#F4F1ED" fontSize="30" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          Place
        </text>

        {/* branch nodes */}
        {BRANCHES.map((b, i) => (
          <g key={`bn-${i}`}>
            <circle cx={b.x} cy={branchY} r="3" fill="#D4A373">
              <animate attributeName="opacity" values="0.4;1;0.4" dur={`${3 + (i % 4)}s`} repeatCount="indefinite" />
            </circle>
            <text x={b.x} y={branchY - 16} textAnchor="middle" fill="#C9C5BE" fontSize="19" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {b.label}
            </text>
          </g>
        ))}

        {/* spine nodes */}
        {SPINE.map((s, i) => (
          <g key={`sn-${i}`}>
            <circle cx={placeX} cy={s.y} r={i === SPINE.length - 1 ? "5" : "3.5"} fill="#D4A373" />
            <text x={placeX} y={s.y + 34} textAnchor="middle" fill={i === SPINE.length - 1 ? "#E6CCB2" : "#F4F1ED"} fontSize={i === SPINE.length - 1 ? "28" : "24"} style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {s.label}
            </text>
          </g>
        ))}
      </svg>
    </div>
  );
}
